import { render, staticRenderFns } from "./TopTitle.vue?vue&type=template&id=50035aae&scoped=true&"
import script from "./TopTitle.vue?vue&type=script&lang=js&"
export * from "./TopTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopTitle.vue?vue&type=style&index=0&id=50035aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50035aae",
  null
  
)

export default component.exports